import React from 'react'
import { Card, CardContent, IconButton, makeStyles, Typography } from '@material-ui/core'
import { indigo } from '@material-ui/core/colors'
import VolumeUpIcon from '@material-ui/icons/VolumeUp'

const useStyles = makeStyles((theme) => ({
	container: {
		position: 'relative',
		textAlign: 'center',
		transition: 'background-color ease 0.25s',
		borderRight: '2px dashed #393939',
	},
	containerLast: {
		position: 'relative',
		textAlign: 'center',
		transition: 'background-color ease 0.25s',
	},
	card: {
		backgroundColor: 'transparent',
		'&:hover': {
			backgroundColor: '#4d4e50'
		}
	},
	iconButtonPlay: {
		position: 'absolute',
		opacity: 0,
		right: 4,
		top: 4,
		width: 42,
		height: 42,
		color: 'darkgrey',
		transition: 'color 0.25s, opacity 0.25s',
		'&:hover': {
			color: 'lightgray',
		},
	},
	iconPlay: {
		fontSize: 24,
	},
}))

const EditorChordCard = (props: {
	chord: any,
	onChange?: (chord: any) => void,
	onPlayClick: (chord: any) => void,
	selected?: boolean,
	last: boolean
}) => {

	const {
		chord,
		onChange,
		selected = false,
		onPlayClick,
		last
	} = props

	const classes = useStyles()

	return (
		<div className={last ? classes.containerLast : classes.container}>
			<Card
				className={classes.card}
				style={{
					width: 190 - (selected ? 6 * 2 : 0),
					border: selected ? '6px solid ' + indigo[300] : undefined,
					height: 120 - (selected ? 6 * 2 : 0),
					display: 'flex',
					alignContent: 'center',
					justifyContent: 'center',
					margin: 0,
					cursor: 'pointer',
					borderRadius: 0,
				}}
				onClick={onChange ? () => onChange(chord) : undefined}
				elevation={0}
			>
				<CardContent style={{
					display: 'flex',
					alignContent: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
				}}>
					<Typography variant="h5" component="h2" style={{ marginBottom: 4 }}>
						{chord.symbol}
					</Typography>
					<Typography variant="body2" component="p">
						{chord.notes.join(' • ')}
					</Typography>
				</CardContent>

				<IconButton onClick={(e) => {e.stopPropagation(); onPlayClick(chord)}} className={classes.iconButtonPlay} edge="start" color="inherit" aria-label="play audio">
					<VolumeUpIcon className={classes.iconPlay} />
				</IconButton>

			</Card>
		</div>
	)
}

export default EditorChordCard
